module.exports = __webpack_public_path__ + "media/images/icons/keyboard-bf192e46868fae23a763ca74cb3218b3.svg";